// Tratamento de erro das planilhas (Cardápio → Produtos e Módulo Fiscal usam a
// MESMA planilha desde 02/10/2026 — features/cardapio-planilha). A planilha só
// fiscal que existia aqui saiu da tela.

/** Texto do erro sem derrubar a tela: 422 do FastAPI vem como lista. */
export async function mensagemDeErro(e, padrao) {
  let detail = e?.response?.data?.detail;
  // Resposta de download chega como Blob mesmo quando é erro JSON.
  if (!detail && e?.response?.data instanceof Blob) {
    try {
      detail = JSON.parse(await e.response.data.text())?.detail;
    } catch {
      detail = null;
    }
  }
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail) && typeof detail[0]?.msg === "string") return `${padrao}: ${detail[0].msg}`;
  return padrao;
}
